import { noPrefixRegion } from '@/plugins/region.ts'
import { isKnownRoute } from '@/router/href-localizer.ts'
import type { RegionCode } from '@/graphql/api'
import type { RedirectFunction } from 'wucdbm-vite-vue-ssr'
import type { Router } from 'vue-router'
import type { Routes } from '@/router/routes.ts'

export async function handleRedirection(
    regionCode: RegionCode,
    redirect: RedirectFunction,
    router: Router,
    routes: Routes,
    target: string,
    code: number
): Promise<void> {
    if (regionCode === noPrefixRegion) {
        return await redirect(target, code)
    }
    const route = router.resolve(target)

    if (!isKnownRoute(route)) {
        return await redirect(target, code)
    }

    const fullPath = router.resolve(
        routes.localize({
            name: route.name,
            hash: route.hash,
            params: route.params,
            query: route.query,
        })
    ).fullPath

    await redirect(fullPath, code)
}
